<template>
  <nav class="navbar navbar-light">
    <div class="navlogo">
      <a href="#" target="_blank">
        <img src="./../../assets/images/hrdesk-logo-dark-beta.png" class="header__logo" alt="logo" />
      </a>
    </div>

    <div class="mini-menu" id="sidebarCollapse">
      <img src="./../../assets/style/images/speech-bubble.svg" />
      <a> <font-awesome-icon icon="bars" />Menu </a>
    </div>

    <div class="header__navbar--profile">
      <div class="header__navbar--profile-name" @click="dropDown">
        {{ userName }}
      </div>
      <div class="header__navbar--profile-avatar" @click="dropDown">
        <img src="./../../assets/images/user.svg" alt />
      </div>
      <div class="header__navbar--profile-dropdown" v-show="headerDropDown">
        <div>
          <routerLink to="/personal-details">Profile</routerLink>
        </div>
        <div @click="logOut">Log Out</div>
      </div>
    </div>
  </nav>
</template>

<script>
import * as types from "../../store/constant";

export default {
  name: "EmployeeHeader",
  data() {
    return {
      userName: "Loading",
      headerDropDown: false,
    };
  },
  methods: {
    dropDown() {
      if (this.headerDropDown) {
        this.headerDropDown = false;
      } else {
        this.headerDropDown = true;
      }
    },
    logOut() {
      this.$store
        .dispatch(types.AUTH_LOGOUT)
        .then(() => {
          this.$router.push("/login");
        })
        .catch();
    },
  },
  created() {
    let user = this.$store.getters.currentAuthUser;
    this.userName = user.firstname + " " + user.lastname;
  },

  mounted() {
    $(document).ready(function () {
      $("#sidebarCollapse").on("click", function () {
        document.getElementById("offCanvas").checked = !document.getElementById(
          "offCanvas"
        ).checked;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
nav {
  background-color: #ffffff;

  * {
    width: auto;
  }

  >.navlogo {
    max-width: 150px;

    >a {
      >img {
        width: 100%;
      }
    }
  }

  >.header__logo {
    max-width: 10.229vw;
    padding-top: 0;
    border: 1px solid red;
  }

  .header__navbar--profile {
    height: 50px;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;

    >.header__navbar--profile-name {
      width: 70px;
      height: 30px;
      cursor: pointer;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #707070;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-top: 10px;
    }

    >.header__navbar--profile-avatar {
      width: 30px;
      height: 30px;
      border-radius: 60px;
      text-align: center;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 30px;
        height: 30px;
      }
    }

    >.header__navbar--profile-dropdown {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      overflow: hidden;
      background: #fbfafa;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

      >div {
        height: 30px;
        padding-left: 20px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 1.042vw;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        >a {
          text-decoration: none;
          color: #000;
        }
      }
    }
  }

  .mini-menu {
    display: none;
    cursor: pointer;

    img {
      width: 26.7px;
      height: 24px;
      margin-right: 10px;
    }
  }

  @media (max-width: 800px) {
    .mini-menu {
      display: flex;
    }

    .header__navbar--profile {
      display: none;
    }
  }
}

@media (max-width: 600px) {
  .header__logo {
    max-width: 200px !important;
  }
}

@media (max-width: 415px) {
  .header__logo {
    max-width: 150px !important;
  }
}
</style>
